import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">My Taxes Today</p>
        <h1>Your Trusted Partner for Tax Solutions</h1>
        <p className="lede">
          Simplify your tax season with My Taxes Today. We provide expert guidance and resources to help you navigate your tax needs with confidence.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Expert Guidance</h2>
          <p>
            Our team of tax professionals is here to provide personalized advice tailored to your unique financial situation.
          </p>
        </article>
        <article>
          <h2>Comprehensive Resources</h2>
          <p>
            Access a wealth of information and tools designed to help you understand your tax obligations and maximize your returns.
          </p>
        </article>
        <article>
          <h2>Stress-Free Filing</h2>
          <p>
            Let us handle the complexities of tax filing so you can focus on what matters most. We ensure accuracy and compliance every step of the way.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;